<template>
  <div id="noon-form-select">
    <vs-row vs-w="12">
      <vs-col vs-justify="flex-start" vs-align="center" vs-w="6">
        <label class="vs-input--label aisea-text-14-400-dark-gray pl-0">{{
          form.label
        }}</label>
        <treeselect
          v-model="inputValue"
          :multiple="false"
          :options="options"
          placeholder=""
          :searchable="false"
          :clearable="false"
        >
          <label
            :class="{ 'alert-text': node.raw.isAlert }"
            slot="option-label"
            slot-scope="{ node }"
          >
            {{ node.label }}
          </label>
          <div
            :class="{ 'alert-text': node.raw.isAlert }"
            slot="value-label"
            slot-scope="{ node }"
          >
            {{ node.raw.label }}
          </div>
        </treeselect>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

import { DeviceInfoMixin, ColorMixin } from "@/mixins";

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {
    form: { type: Object, required: true },
    value: { required: false },
  },
  data() {
    return {
      value2: null,
      options: [],
      inputValue: null,
    };
  },
  components: {
    Treeselect,
  },
  watch: {
    inputValue: {
      handler(val) {
        let payload;
        if (val) {
          let obj = this.form.select_options.find(item => item.value === val);
          payload = {
            id: this.form.id,
            label: obj.label,
            value: obj.value,
            isAlert: obj.is_alert,
          };
        } else {
          payload = {
            id: this.form.id,
            label: "",
            value: "",
            isAlert: false,
          };
        }
        this.$emit("setValue", payload);
      },
      deep: true,
    },
  },

  mounted() {
    this.form.select_options.forEach(el => {
      this.options.push({
        id: el.value,
        label: el.label,
        isAlert: el.is_alert,
      });
    });

    if (this.value) {
      let opj = this.form.select_options.find(
        item => item.value === this.value
      );
      this.inputValue = opj.value;
    } else {
      this.inputValue = this.form.default_value;
    }
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/vessel-noon-report.scss";

#noon-form-select {
  .vue-treeselect__control {
    height: 50px !important;
  }

  .vue-treeselect__single-value {
    font-size: 1.2rem !important;
    color: #626262;
    padding: 0.5rem !important;
  }

  .vue-treeselect__menu-container {
    font-size: 1.2rem !important;
  }

  --vs-primary: 3, 155, 229;
}
</style>
